<div class="loading_container">
  <img src="/assets/img/circle-loader.svg" />
  <span>Loading...</span>
</div>
